<!-- 学籍卡 -->
<template>
    <div class="el-studentCard">
        <el-row class="page_content">
            <!-- <el-row style="text-align:right;">
                 <el-button class="but" type="primary" plain icon="el-icon-more">编辑</el-button>
                <el-button class="but" type="primary" @click="printNow" plain icon="el-icon-printer">打印</el-button>
                 <el-button class="but" type="primary" @click="downloadNow" plain icon="el-icon-download">导出</el-button>
            </el-row> -->
            <el-row>
                <!-- <el-row id='printBill' v-html="htmlInfo">

                </el-row> -->
                <templateEdit :toolShow="true" templateName="学籍卡"></templateEdit>
            </el-row>
        </el-row>
    </div>
</template>
<script>
import print from "print-js";
import templateEdit from "@/components/templateEdit";	//模板
export default {
  name: "StudentCard",
  components: {
  	templateEdit
  },
  data() {
    return {
        htmlInfo:"",
        studentInfo:{},//学生信息
    };
  },
  created() {
    // this.getUseImgTemplate();
    this.studentInfo = JSON.parse(sessionStorage.getItem(this.$getStudentInfoKeyForRoleTag()));
  },
  methods: {
    printNow(){ //打印录取通知书
        const style = '@page {margin:0 10mm};'//打印时去掉眉页眉尾
        //打印为什么要去掉眉页眉尾？因为眉页title时打印当前页面的title，相当于是获取html中title标签里面的内容，但是比如我打印的内容只是一个弹框里面的内容，是没有title的，这时候就会出现undefined，为了避免出现这种情况，就可以隐藏眉页眉尾
        printJS({
          printable: 'printBill',// 标签元素id
          type: 'html',
          header: '',
          targetStyles: ['*'],
          style
        });
    },
    getUseImgTemplate(){ //获取录取通知书
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$store.dispatch("user/useTableTemplate",{templateName:"学籍卡"}).then((ret) => {
            loading.close();
            if(ret.code == 0){
                if(ret.data.length > 0){
                    this.htmlInfo = ret.data[0];
                }else{
                    this.$message({message: "通知书生成失败！",type:"warning"});
                }
            }else{
              this.$message({message: ret.msg,type: "warning"});
            }
        });
    },
    downloadNow(){ //导出
        if(!this.$isEmpty(this.studentInfo.studentId)){
            this.$downLoadFile("/api/student/exportTableTemplateToPdf.do?templateName=毕业生登记表&studentId="+this.studentInfo.studentId,this.studentInfo.studentName+"__毕业生登记表.zip");
        }else{
            this.$message.warning("学生数据丢失！");
        }
    }
  }
};
</script>
<style  lang="less">
  @import '../../styles/base.less';
  .el-studentCard{
    .page_content{
        padding: 20px;
    }
    // #printBill{
    //     width: 1060px;
    //     table{
    //         width: 100% !important;
    //         tr{
    //             page-break-inside: avoid; //避免打印被截断
    //         }
    //     }
    // }
    .but{
        font-size: 20px;
        border-color:@bgZS;
        color:@bgZS;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/user/StudentCard.vue